import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  CardMedia, 
  Typography, 
  Select, 
  MenuItem, 
  TextField, 
  InputAdornment, 
  Chip, 
  Button, 
  Modal, 
  IconButton, 
  Divider, 
  FormControlLabel, 
  Slider, 
  ButtonGroup, 
  Checkbox, 
  ToggleButtonGroup, 
  ToggleButton,
  Pagination,
  CircularProgress,
  useTheme,
  Tooltip,
  FormControl,
  InputLabel,
  ListItemText
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { GoogleMap, LoadScript, Marker, InfoWindow, OverlayView } from '@react-google-maps/api';
import 'leaflet/dist/leaflet.css';
import L, { divIcon } from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import DashboardCard from '../../../components/shared/DashboardCard';
import { 
    Home as HomeIcon,
    Hotel as BedIcon, 
    Bathtub as BathtubIcon,
    AcUnit as AcUnitIcon,
    LocalParking as LocalParkingIcon, 
    Apps,
    Apartment,
    Home,
    FavoriteBorder,
    RestartAlt
} from '@mui/icons-material';
import { IconFilter, IconX } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { fget } from '../../../axios/axiosCalls';
import { use } from 'react';
import CustomerListModal from '../../../components/CustomerListModal';
import NoImageFound from '../../../components/NoImageFound';

// Fix default icon issue
import {
  Weekend as LivingIcon,
  Kitchen as KitchenIcon,
  Shower as ShowerIcon,
  LocalLaundryService as WashingIcon,
  Hvac as HeatingIcon,
  KingBed as CoupleIcon,
  Microwave as MicrowaveIcon,
  Tv as TvIcon,
  DryCleaningOutlined as DryerIcon,
  LocalParking as ParkingIcon,
  Deck as GardenIcon,
  SmokeFree as NoSmokingIcon,
  CleaningServices as CleanerIcon,
  ChildCare as KidsIcon,
  Delete as WasteIcon,
  Recycling as RecycleIcon,
  LocalDining as DiningIcon,
  AcUnit as AcIcon,
  Wifi as WifiIcon // Keep this import
} from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import { debounce, filter } from 'lodash';
import ListingCard from '../../../components/Explore/ListingCard';
import MapComponent from '../../../components/Explore/MapComponent';
import ReactNestedSelect from '../../../components/ReactNestedSelect';
import { priceFormattingSymbol } from '../../../utils/utils';
import Footer from '../../../components/Footer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const mapContainerStyle = {
  width: '100%',
  height: '400px',
  borderRadius: '16px',
  overflow: 'hidden'
};
// const universities = [
//   { id: 1, name: 'University of Cambridge', location: { lat: 52.2054, lng: 0.1132 } },
//   { id: 2, name: 'Oxford University', location: { lat: 51.7548, lng: -1.2544 } },
//   { id: 3, name: 'Imperial College London', location: { lat: 51.4988, lng: -0.1749 } },
//   { id: 4, name: 'University College London', location: { lat: 51.5246, lng: -0.1339 } },
//   { id: 5, name: 'London School of Economics', location: { lat: 51.5144, lng: -0.1167 } },
// ];

const AMENITIES_CONFIG = {
  living: { label: 'Living Room', icon: LivingIcon },
  shower: { label: 'Shower', icon: ShowerIcon },
  shower_half: { label: 'Half Shower', icon: ShowerIcon },
  kitchen: { label: 'Kitchen', icon: KitchenIcon },
  parking: { label: 'Parking', icon: ParkingIcon },
  wifi: { label: 'WiFi', icon: WifiIcon },
  kids: { label: 'Kid Friendly', icon: KidsIcon },
  couple: { label: 'Couple Friendly', icon: CoupleIcon },
  heating: { label: 'Heating', icon: HeatingIcon },
  ac: { label: 'Air Conditioning', icon: AcIcon },
  fridge: { label: 'Fridge', icon: KitchenIcon },
  freezer: { label: 'Freezer', icon: KitchenIcon },
  wmachine: { label: 'Washing Machine', icon: WashingIcon },
  dryer: { label: 'Dryer', icon: DryerIcon },
  ctop: { label: 'Cooktop', icon: DiningIcon },
  stable: { label: 'Study Table', icon: LivingIcon },
  micoven: { label: 'Microwave', icon: MicrowaveIcon },
  hoover: { label: 'Vacuum Cleaner', icon: CleanerIcon },
  lmover: { label: 'Lawn Mower', icon: CleanerIcon },
  showel: { label: 'Shovel', icon: CleanerIcon },
  toaster: { label: 'Toaster', icon: KitchenIcon },
  tv: { label: 'TV', icon: TvIcon },
  dishwasher: { label: 'Dishwasher', icon: KitchenIcon },
  brgarden: { label: 'Garden', icon: GardenIcon },
  orfwaste: { label: 'Organic Waste', icon: WasteIcon },
  blnrecyclable: { label: 'Blue Recyclable', icon: RecycleIcon },
  grecyclable: { label: 'Green Recyclable', icon: RecycleIcon },
  grbcpapers: { label: 'Paper Recycling', icon: RecycleIcon },
  no_smoking: { label: 'No Smoking', icon: NoSmokingIcon },
  entertaintment: { label: 'Entertainment', icon: LivingIcon },
  communal_laundry: { label: 'Communal Laundry', icon: WashingIcon },
  fully_furnished: { label: 'Fully Furnished', icon: LivingIcon }
};

const Explore = () => {
  const [selectedUniversity, setSelectedUniversity] = useState('');
  const [universities, setUniversities] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [openFilter, setOpenFilter] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const [searchParams, setSearchParams] = useSearchParams();

  const [tempFilters, setTempFilters] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const today = new Date().toISOString().split('T')[0];
    return {
      startDate: params.get('startDate')|| new Date().toISOString().split('T')[0] ,
      country: params.get('country') || '',
      university: params.get('university') || '',
      campus: params.get('campus') || '',
      universityName: params.get('universityName') || '',
      isActive: params.get('isActive') || '1',
      term: params.get('term') || ''  // Add this line
    };
  });
  
  const [areFiltersApplied, setAreFiltersApplied] = useState(false);

  const [filters, setFilters] = useState({
    propertyType: 'all',
    campus: '',
    priceRange: [0, 10000],
    distance: 25,
    entireRoom: false,
    rooms: 'Any',
    beds: 'Any',
    startDate: '',
    isActive: 1,
    amenities: Object.keys(AMENITIES_CONFIG).reduce((acc, key) => {
      acc[key] = '0';
      return acc;
    }, {}),
    managementType: 'all' // Add this line
  });
  const [selectedMarker, setSelectedMarker] = useState(null);

  const provinceId = searchParams.get('city');
  
  const [selectedTown, setSelectedTown] = useState(provinceId);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [listings, setListings] = useState([]);
  const mapRef = useRef(null);
  const listRefs = useRef({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const PAGE_SIZE = 10;
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countries, setCountries] = useState([]);
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
  const currentUser = { id: 1, name: 'John Doe' }; // Replace with actual user data
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const google = window.google || {};
  const [selectedCampus, setSelectedCampus] = useState('');
  const [campuses, setCampuses] = useState([]);
  const nestedSelectRef = useRef(null);

  const [totalBedspaces, setTotalBedspaces] = useState(0);
  const theme = useTheme();
  const initialTempFilters = {
    startDate: new Date().toISOString().split('T')[0],
    country: '',
    university: '',
    campus: '',
    term: '' // Add this line
  };
  
  const initialFilters = {
    propertyType: 'all',
    campus: '',
    priceRange: [0, 10000], // Changed from 2000 to 5000
    distance: 25,
    entireRoom: false,
    rooms: 'Any',
    beds: 'Any',
    startDate: '',
    isActive: 1,
    amenities: Object.keys(AMENITIES_CONFIG).reduce((acc, key) => {
      acc[key] = '0';
      return acc;
    }, {}),
    managementType: 'all' // Add this line
  };
  
  const PriceMarker = ({ listing, onClick }) => (
    <OverlayView
      position={listing.location}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Box
        onClick={onClick}
        style={{
          position: 'absolute',
          left: '-50%',
          top: '-50%',
          backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#FFF',
          border: `2px solid ${theme.palette.primary.main}`,
          borderRadius: '9999px',
          padding: '6px 16px',
          color: theme.palette.mode === 'dark' ? '#FFF' : theme.palette.primary.main,
          fontWeight: '700',
          fontSize: '14px',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          boxShadow: theme.palette.mode === 'dark' ? '0 0 8px rgba(0,0,0,0.5)' : 'none'
        }}
      >
        £{listing.price}
      </Box>
    </OverlayView>
  );
  useEffect(() => {
    const initializeFromParams = async () => {
      const params = new URLSearchParams(window.location.search);
      const provinceId = params.get('province');
      const cityId = params.get('city');
  
      if (provinceId) {
        try {
          // Fetch provinces if we have a provinceId
          const response = await fget({
            url: '/api/v2/provinces',
            params: { countryId: tempFilters.country }
          });
          
          if (response.data.status === 'Success') {
            const provinces = transformProvincesToNestedFormat(response.data.towns);
            setNestedProvinces(provinces);
            
            // Find the province and city
            const province = response.data.towns.find(p => p.id === provinceId);
            const city = province?.towns.find(t => t.id === cityId);
            
            if (province) {
              setSelectedProvince(provinceId);
              setTempFilters(prev => ({
                ...prev,
                province: provinceId
              }));
  
              if (city && cityId) {
                setSelectedTown(cityId);
                setTempFilters(prev => ({
                  ...prev,
                  city: cityId
                }));
              }
              
              // Set initial filter state
              setAreFiltersApplied(true);
            }
          }
        } catch (error) {
          console.error('Error fetching provinces:', error);
        }
      }
    };
  
    initializeFromParams();
  }, []); // Run once on component mount
  const onLoad = useCallback(map => {
    mapRef.current = map;
  }, []);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fget({url:'/api/v2/countries'});
        setCountries(response.data.countries);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    }
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchColleges = async () => {
      try {
        const response = await fget({url:'/api/v2/colleges', params:{countryId:tempFilters.country}});
        setUniversities(response.data.colleges);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    }
    fetchColleges();
  }, [tempFilters?.country]);
  const [provinces, setProvinces] = useState([]);
  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState(searchParams.get('province') || '');
  const [nestedProvinces, setNestedProvinces] = useState([]);

  const transformProvincesToNestedFormat = (provinces) => {
    return provinces.map(province => ({
      label: province.provinceName,
      value: province.id,
      options: province.towns.map(town => ({
        label: town.name,
        value: town.id
      }))
    }));
  };

  useEffect(() => {
    const params = new URLSearchParams();
    
    if (tempFilters.startDate) params.set('startDate', tempFilters.startDate);
    if (tempFilters.country) params.set('country', tempFilters.country);
    if (tempFilters.campus) params.set('campus', tempFilters.campus);
    if (selectedProvince) params.set('province', selectedProvince);
    if (tempFilters) params.set('university', tempFilters.university);
    if (tempFilters) params.set('universityName', tempFilters.universityName);
    if (tempFilters.isActive) params.set('isActive', tempFilters.isActive); // Add this line
    if (tempFilters.term) params.set('term', tempFilters.term); // Add this line
    
    if (selectedTown) params.set('city', selectedTown);

    setSearchParams(params);
  }, [tempFilters.startDate, tempFilters.country, tempFilters.campus, selectedProvince,tempFilters.university, tempFilters.isActive,selectedTown, tempFilters.term]);
  
  const fetchProvinces = async () => {
    try {
      setLoadingProvinces(true);
      const response = await fget({url:'/api/v2/provinces',params:{countryId: tempFilters.country}});
      if (response.data.status === 'Success') {
        setNestedProvinces(transformProvincesToNestedFormat(response.data.towns));
      }
    } catch (error) {
      console.error('Error fetching provinces:', error);
    } finally {
      setLoadingProvinces(false);
    }
  };
  useEffect(() => {
    if (tempFilters.country) {
      fetchProvinces();
    } else {
      setProvinces([]);
      setSelectedProvince(null);
    }
  }, [tempFilters.country]);
  const handleResetAllFilters = useCallback(() => {
    setSearchTerm(''); // Add this line
    fetchProperties({ pageParam: 1, resetFilters: true });
  }, [setSearchParams, PAGE_SIZE]);
  useEffect(() => {
    const fetchCampuses = async () => {
      if (tempFilters.university) {
        try {
          const response = await fget({
            url: '/api/v2/campuses', 
            params: { collegeId: tempFilters.university,countryId: tempFilters.country }
          });
          setCampuses(response.data.campuses);
        } catch (error) {
          console.error('Error fetching campuses:', error);
        }
      } else {
        setCampuses([]);
      }
    };
    if (tempFilters.university) {
      fetchCampuses();
    }
    
  }, [tempFilters?.university]);
  const handleUniversityChange = (e) => {
    const universityId = e.target.value;
    setSelectedUniversity(universityId);
    const university = universities.find(u => u.id === universityId);
    if (university && mapRef.current) {
      mapRef.current.panTo({
        lat: university.location.lat,
        lng: university.location.lng
      });
      mapRef.current.setZoom(13);
    }
  };

  const getCurrentLocation = () => {
    if (selectedUniversity) {
      return universities?.find(u => u.id === selectedUniversity)?.name;
    }
    return 'All locations';
  };


  const transformUniversitiesToNestedFormat = (universities) => {
    return universities?.map(uni => ({
      label: uni.name,
      value: uni.collegeId,
      options: uni.campuses?.map(campus => ({
        label: campus.campusName,
        value: campus.id
      }))
    }));
  };
  const handleMarkerClick = useCallback((listing) => {
    if (mapRef.current) {
      mapRef.current.panTo({
        lat: listing.location.lat,
        lng: listing.location.lng
      });
      mapRef.current.setZoom(15);
    }

    navigate(`/property/${listing.id}`);

  }, [navigate]);

  const getTotalBedspaces = (listings) => {
    return ;
  };
 
  // Filter listings based on search term
  // const filteredListings = listings.filter(listing => {
  //   if (searchTerm) {
  //     const searchStr = searchTerm.toLowerCase();
  //     return (
  //       listing.title.toLowerCase().includes(searchStr) ||
  //       listing.university.toLowerCase().includes(searchStr) ||
  //       listing.type.toLowerCase().includes(searchStr)
  //     );
  //   }
  //   return true;
  // });
  

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({top: 0, behavior: 'smooth'});
  };
  const getBounds = (listings) => {
    if (!listings.length) return null;
    
    const bounds = new window.google.maps.LatLngBounds();
    
    listings.forEach(listing => {
      bounds.extend(new window.google.maps.LatLng(
        listing.location.lat,
        listing.location.lng
      ));
    });
    
    return bounds;
  };
  const defaultCenter = { lat: 54.7023545, lng: -3.2765753 };
  const defaultZoom = 5;
  // useEffect(() => {
  //   if (mapRef.current && listings.length > 0) {
  //     const bounds = getBounds(listings);
  //     if (bounds) {
  //       mapRef.current.fitBounds(bounds);
  //     }
  //   } else if (mapRef.current && selectedUniversity) {
  //     const uni = universities.find(u => u.collegeId === selectedUniversity);
  //     if (uni?.latitude && uni?.longitude) {
  //       mapRef.current.panTo({
  //         lat: parseFloat(uni.latitude),
  //         lng: parseFloat(uni.longitude)
  //       });
  //       mapRef.current.setZoom(13);
  //     }
  //   }
  // }, [listings,]);
  useEffect(() => {
    const paramUniversity = searchParams.get('university');
    if (paramUniversity && !tempFilters.university) {
      const university = universities?.find(u => u.collegeId === paramUniversity);
      if (university) {
        setTempFilters(prev => ({
          ...prev,
          university: paramUniversity
        }));
        setSelectedUniversity(paramUniversity);
      }
    }
  }, [searchParams, universities]);
  useEffect(() => {
    const initializeFromParams = async () => {
      const params = new URLSearchParams(window.location.search);
      const countryId = params.get('country');
      const universityId = params.get('university');
      
      if (countryId) {
        // Fetch countries if not loaded
        if (countries.length === 0) {
          const countryResponse = await fget({url:'/api/v2/countries'});
          setCountries(countryResponse.data.countries);
        }
        
        // Fetch universities for the country
        const collegesResponse = await fget({
          url:'/api/v2/colleges', 
          params: {countryId}
        });
        setUniversities(collegesResponse.data.colleges);
        
        if (universityId) {
          const university = collegesResponse.data.colleges.find(u => u.collegeId === universityId);
          if (university) {
            setTempFilters(prev => ({
              ...prev,
              country: countryId,
              university: universityId
            }));
            setSelectedUniversity(universityId);
            
            // Fetch campuses if available
            const campusResponse = await fget({
              url: '/api/v2/campuses',
              params: { 
                collegeId: universityId,
                countryId: countryId 
              }
            });
            setCampuses(campusResponse.data.campuses);
          }
        }
        
        // Trigger initial search
        fetchProperties({ pageParam: 1 });
      }
    };
  
    initializeFromParams();
  }, []); // Run once on mount
  useEffect(() => {
    const paramUniversity = searchParams.get('university');
    if (paramUniversity && !tempFilters.university) {
      setTempFilters(prev => ({
        ...prev,
        university: paramUniversity
      }));
      setSelectedUniversity(paramUniversity);
    }
  }, [searchParams, tempFilters.university]);
  const handleSearch = () => {
    setPage(1);
    setTempFilters(prev => ({
      ...prev,
      term: searchTerm // Add this line
    }));
    fetchProperties({ pageParam: 1 });
  };
  // 1. Add a unified fetchProperties function
const fetchProperties = async ({
  pageParam = 1,
  resetFilters = false,
  isShowResults = false,
  term
}) => {
  try {
    setLoading(true);

    // If resetting filters
    if (resetFilters) {
      setFilters(initialFilters);
      setTempFilters(initialTempFilters);
      setSelectedProvince('');
      setAreFiltersApplied(false);
      setSearchParams({});
      if (nestedSelectRef.current) nestedSelectRef.current.reset();
    }

    // Base request body
    const requestBody =Object.entries({
      // studentId: selectedCustomer?.studentId ?? '',
      country: tempFilters.country,
      campus: tempFilters.campus,
      college: tempFilters.university,
      // province: selectedProvince || '',
      town: selectedProvince ?? '',
      fromDate: tempFilters.startDate,
      term: term || searchTerm,
      page: pageParam.toString(),
      limit: PAGE_SIZE.toString(),
      cityId: selectedTown || undefined,

      ...(filters.isActive === 1 && { isActive: 1 })
    }).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    // Add filters if applied
    if (areFiltersApplied || isShowResults) {
      Object.assign(requestBody, {
        // ...existing filters...
        type: filters.propertyType !== 'all' ? filters.propertyType : undefined,
        minPriceRange: filters.priceRange[0] > 0 ? filters.priceRange[0].toString() : undefined,
        maxPriceRange: filters.priceRange[1] > 0 && filters.priceRange[1]<10000? filters.priceRange[1].toString() : undefined,
        ...(tempFilters.campus && { distance: filters.distance > 0 ? filters.distance.toString() : undefined }),
        entireRoom: filters.entireRoom ? '1' : undefined,
        noOfBeds: filters.beds !== 'Any' ? filters.beds.toString() : undefined,
        noOfRooms: filters.rooms !== 'Any' ? filters.rooms.toString() : undefined,
        noOfBathrooms: filters.bathrooms > 1 ? filters.bathrooms.toString() : undefined,
        ...Object.entries(filters.amenities).reduce((acc, [key, value]) => {
          if (value === '1') {
            acc[key] = value;
          }
          return acc;
        }, {}),
        "managementType[]": filters.managementType !== 'all' ? filters.managementType : undefined,
        cityId: selectedTown || undefined,
        town: selectedProvince || undefined
      });
      
    }
    
    const response = await fget({ url: '/api/v2/properties', params: requestBody });
    // ... rest of the function remains same
    if (response.data.status === 'Success') {
      const properties = response.data.data;
      const mappedListings = properties.map(property => ({
        id: property.id,
        title: property.propertyName,
        images: property.image?.imageUrls || [],
        image: property.image?.imageUrls?.[0]?.url || null,
        price: getMinimumBedRate(property.rooms),
        rooms: property.rooms,
        country: property.country,
        managingType: property.managingType,
        location: {
          lat: parseFloat(property.lat),
          lng: parseFloat(property.lng)
        },
        university: property.nearestCollege || '',
        distance: property.distanceList ? JSON.parse(property.distanceList)[0] || 0 : 0,
        type: property.propertyType || '',
        beds: property?.totalCapacity || 1,
        baths: property.amenities?.shower || 1,
        amenities: Object.entries(property.amenities)
          .filter(([_, value]) => value === 'yes' || value === '1')
          .map(([key]) => key),
        compatibility: 0,
        isBillIncluded: property.isBillIncluded,
      }));
      

      setListings(mappedListings);
      setTotalCount(response.data.pagination.totalCount);
      setTotalBedspaces(response.data.pagination.totalBedsCount);
      setTotalPages(Math.ceil(response.data.pagination.totalCount / PAGE_SIZE));
    }
  } catch (error) {
    console.error('Error fetching properties:', error);
  } finally {
    setLoading(false);
    setOpenFilter(false);
  }
};
  useEffect(() => {
    fetchProperties({ pageParam: page });
  }, [page]);

  // Add new function to count active filters
const getActiveFiltersCount = () => {
  const counts = {
    propertyType: filters.propertyType !== 'all' ? 1 : 0,
    price: (filters.priceRange[0] > 0 || filters.priceRange[1] < 10000) ? 1 : 0,
    distance: (tempFilters.campus && filters.distance !== 5) ? 1 : 0, 
    rooms: filters.rooms !== 'Any' ? 1 : 0,
    beds: filters.beds !== 'Any' ? 1 : 0,
    amenities: Object.values(filters.amenities).filter(v => v === '1').length,
    country: tempFilters.country ? 1 : 0,
    university: tempFilters.university ? 1 : 0,
    campus: tempFilters.campus ? 1 : 0,
    date: tempFilters.startDate ? 1 : 0,
    availability: filters.isActive === 1 ? 1 : 0,
    managementType: filters.managementType !== 'all' ? 1 : 0, // Add this line
    selectedProvince: selectedProvince ? 1 : 0,
    selectedTown: selectedTown ? 1 : 0
  };

  return Object.values(counts).reduce((a, b) => a + b, 0);
};

const [searchResults, setSearchResults] = useState({
  properties: [],
  countries: [],
  provinces: [],
  towns: [],
  colleges: [],
  campuses: []
});

const [showSuggestions, setShowSuggestions] = useState(false);

// Add loading state
const [loadingSuggestions, setLoadingSuggestions] = useState(false);

// Add debounced search function
const debouncedSearch = useCallback(
  debounce(async (term) => {
    if (term.length < 2) return;
    
    try {
      setLoadingSuggestions(true);
      const response = await fget({
        url: '/api/v2/search',
        params: { term }
      });
      
      if (response.data.status === 'Success') {
        setSearchResults(response.data);
        setShowSuggestions(true);
      }
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setLoadingSuggestions(false);
    }
  }, 300),
  []
);

// Add new refs and state
const searchRef = useRef(null);
const isMounted = useRef(false);

// Add click outside handler
useEffect(() => {
  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

  // Add currency state
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  return (
    <Box sx={{ mt: 2 }}>
      <DashboardCard>
        {/* Filters */}
        <Box sx={{ py: 3 }}>
  <Grid container spacing={2} alignItems="center">
    {/* Search Bar */}
    
    <Grid item xs={12} md={9} sx={{ position: 'relative' }} ref={searchRef}> {/* Add position relative */}
  <TextField
    fullWidth
    placeholder="Search properties by name, location or university..."
    value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      // Only show suggestions if length >= 2
      if (e.target.value.length >= 2) {
        debouncedSearch(e.target.value);
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }}
    onKeyPress={(e) => {
      if (e.key === 'Enter') {
        handleSearch(); // Full search on Enter
      }
    }}
    onFocus={() => {
      if (searchTerm.length >= 2) {
        setShowSuggestions(true);
      }
    }}
    onBlur={() => {
      // Delay hiding suggestions to allow clicking them
      setTimeout(() => {
        if (isMounted.current) {
          setShowSuggestions(false);
        }
      }, 200);
    }}
    size="small"
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={handleSearch}>
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      )
    }}
  />

  {/* Suggestions Dropdown */}
  {showSuggestions && searchTerm.length >= 2 && (
    <Box
      sx={{
        position: 'absolute',
        top: '100%',
        left: 10,
        right: 0,
        bgcolor: 'background.paper',
        boxShadow: 3,
        borderRadius: 1,
        zIndex: 1300, // Increase z-index
        maxHeight: 400,
        overflow: 'auto',
        mt: 0.5, // Add margin top
        width: '100%'
      }}
    >
      {loadingSuggestions ? (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          {/* Properties Section */}
          {searchResults.properties?.length > 0 && (
            <Box sx={{ p: 1 }}>
              <Typography variant="subtitle2" sx={{ px: 1, py: 0.5, color: 'text.secondary',fontWeight: 'bold' }}>
                Properties
              </Typography>
              {searchResults.properties.map(property => (
                <MenuItem 
                  key={property.id}
                  onClick={() => {
                    // navigate(`/property/${property.id}`);
                    setSearchTerm(property.propertyName);
                    setTempFilters(prev => ({
                      ...prev,
                      term: property.propertyName // Add this line
                    }));
                    setShowSuggestions(false);
                    fetchProperties({ 
                      pageParam: 1,
                      term: property.propertyName
                    });
                  }}
                >
                  {property.propertyName}
                </MenuItem>
              ))}
            </Box>
          )}

          {/* Universities Section */}
          {searchResults.colleges?.length > 0 && (
            <Box sx={{ p: 1 }}>
              <Typography variant="subtitle2" sx={{ px: 1, py: 0.5, color: 'text.secondary' ,fontWeight: 'bold'}}>
                Universities
              </Typography>
              {searchResults.colleges.map(college => (
                <MenuItem 
                  key={college.collegeId}
                  onClick={() => {
                    setTempFilters(prev => ({
                      ...prev,
                      university: college.id,
                      universityName: college.collegeName,
                      term: college.collegeName // Add this line
                    }));
                    setSearchTerm(college.collegeName);
                    setShowSuggestions(false);
                    fetchProperties({ 
                      pageParam: 1,
                      term: college.collegeName 
                    });
                  }}
                >
                  {college.collegeName}
                </MenuItem>
              ))}
            </Box>
          )}

          {/* Towns Section */}
          {searchResults.towns?.length > 0 && (
            <Box sx={{ p: 1 }}>
              <Typography variant="subtitle2" sx={{ px: 1, py: 0.5, color: 'text.secondary',fontWeight: 'bold' }}>
                Towns
              </Typography>
              {searchResults.towns.map(town => (
                <MenuItem 
                  key={town.id}
                  onClick={() => {
                    setSelectedProvince(town.id);
                    setSearchTerm(town.name);
                    setTempFilters(prev => ({
                      ...prev,
                      term: town.name // Add this line
                    }));
                    setShowSuggestions(false);
                    fetchProperties({ 
                      pageParam: 1,
                      term: town.name
                    });
                  }}
                >
                  {town.name}
                </MenuItem>
              ))}
            </Box>
          )}

          {/* Provinces Section */}
          {searchResults.provinces?.length > 0 && (
            <Box sx={{ p: 1 }}>
              <Typography variant="subtitle2" sx={{ px: 1, py: 0.5, color: 'text.secondary',fontWeight: 'bold' }}>
                Provinces
              </Typography>
              {searchResults.provinces.map(province => (
                <MenuItem 
                  key={province.id}
                  onClick={() => {
                    setSelectedProvince(province.id);
                    setSearchTerm(province.provinceName);
                    setTempFilters(prev => ({
                      ...prev,
                      term: province.provinceName // Add this line
                    }));
                    setShowSuggestions(false);
                    fetchProperties({ 
                      pageParam: 1,
                      term: province.provinceName
                    });
                  }}
                >
                  {province.provinceName}
                </MenuItem>
              ))}
            </Box>
          )}
        {/* Provinces Section */}
        {searchResults.countries?.length > 0 && (
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ px: 1, py: 0.5, color: 'text.secondary',fontWeight: 'bold' }}>
                      Countries
                      </Typography>
                      {searchResults.countries.map(country => (
                        <MenuItem 
                          key={country.id}
                          onClick={() => {
                            setSelectedCountry(country.id);
                            // setTempFilters(prev => ({
                            //   ...prev,
                            //   country: country.id
                            // }));
                            setSearchTerm(country.cname);
                            setTempFilters(prev => ({
                              ...prev,
                              term: country.cname // Add this line
                            }));
                            setShowSuggestions(false);
                            fetchProperties({ 
                              pageParam: 1,
                              term: country.cname
                            });
                          }}
                        >
                          {country.cname}
                        </MenuItem>
                      ))}
                    </Box>
                  )}
          {/* No Results Message */}
          {!searchResults.properties?.length && 
           !searchResults.colleges?.length && 
           !searchResults.provinces?.length &&
           !searchResults.countries?.length &&
           !searchResults.towns?.length && (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography color="text.secondary">
                No matching results found
              </Typography>
            </Box>
          )}
        </>
      )}
    </Box>
  )}
</Grid>

    {/* Filter Button */}
    

    {/* Reset Filter Button */}
    

    {/* Check-in Date */}
    <Grid item xs={12} md={1.5}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Check-in Date"
          format="DD-MM-YYYY"
          value={tempFilters.startDate ? dayjs(tempFilters.startDate) : null}
          onChange={(newValue) => {
            if (!newValue || !newValue.isValid()) return;
            setTempFilters(prev => ({
              ...prev,
              startDate: newValue.format('YYYY-MM-DD')
            }));
          }}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true
            }
          }}
        />
      </LocalizationProvider>
    </Grid>

    {/* Search Button */}
    <Grid item xs={12} md={1}>
      <Button
        fullWidth
        variant="contained"
        onClick={handleSearch}
      >
        Search
      </Button>
    </Grid>
    <Grid item xs={6} md={0.5}>
      <Tooltip title="Reset Filters">
        <IconButton
          onClick={handleResetAllFilters}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'error.main',
              color: 'error.main'
            }
          }}
        >
          <RestartAlt size={20} />
        </IconButton>
      </Tooltip>
    </Grid>
  </Grid>
  
</Box>

        {/* Map */}
        <Box sx={{ mb: 4, height: '400px', borderRadius: '10px' }}>
          <MapComponent
            googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
            mapContainerStyle={mapContainerStyle}
            selectedUniversity={selectedUniversity}
            defaultCenter={defaultCenter}
            defaultZoom={defaultZoom}
            universities={universities}
            mapRef={mapRef}
            onLoad={onLoad}
            listings={listings}
            selectedMarker={selectedMarker}
            setSelectedMarker={setSelectedMarker}
            handleMarkerClick={handleMarkerClick}
          />
        </Box>
        {selectedCustomer?.studentId && (
            <Box>
              <Box sx={{ 
                mb: 3, 
                mt: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <Typography
                  variant="h5"
                  color="text.secondary"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  Showing Results for Selected User <strong>{selectedCustomer?.name}</strong>
                </Typography>
                <Button
                  startIcon={<RestartAlt />}
                  onClick={() => setSelectedCustomer(null)}
                  color="warning"
                  size="small"
                >
                  Reset Selection
                </Button>
              </Box>
            </Box>
          )}
        <Box sx={{ 
          mb: 3, 
          mt: 2, 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 2, sm: 0 },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between'
        }}>
          
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexWrap: 'wrap',
              width: { xs: '100%', sm: 'auto' }
            }}
          >
        <Grid item xs={6} md={0.4}>
              <Tooltip title={`${getActiveFiltersCount()} filter${getActiveFiltersCount() !== 1 ? 's' : ''} applied`}>
                <IconButton
                  onClick={() => setOpenFilter(true)}
                  sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    position: 'relative',
                    '&:hover': {
                      borderColor: 'primary.main'
                    }
                  }}
                >
                  <IconFilter size={20} />
                  {getActiveFiltersCount() > 0 && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        backgroundColor: 'primary.main',
                        color: 'white',
                        borderRadius: '50%',
                        width: 20,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 12,
                        fontWeight: 'bold'
                      }}
                    >
                      {getActiveFiltersCount()}
                    </Box>
                  )}
                </IconButton>
              </Tooltip>
            </Grid>
            <Box component="span" sx={{ mx: 0.2 }}>&nbsp;</Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>{totalCount} {totalCount === 1 ? 'Property' : 'Properties'}</span>
              <span>•</span>
              <span>{totalBedspaces} {totalBedspaces === 1 ? 'Bedspace' : 'Total Bedspaces'}</span>
            </Box>
          </Typography>
          
          {/* <TextField
            placeholder="Search towns and properties..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
            sx={{ 
              width: { xs: '100%', sm: 300, md: 500 }  // Increased width
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch}
                    edge="end"
                    size="small"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              )
            }}
          /> */}
        </Box>
        
        {/* Listings Grid */}
        <Box>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {listings.map((listing) => (
                  <ListingCard 
                  key={listing.id}
                  listing={listing}
                  selectedCustomer={selectedCustomer}
                  ref={el => listRefs.current[listing.id] = el}

                  onClick={() => navigate(`/property/${listing.id}${tempFilters.startDate ? `?fromDate=${tempFilters.startDate}` : ''}`)}                  
                  sx={{
                    display: 'flex',
                    mb: 2,
                    height: 250,
                    position: 'relative',
                    border: theme => `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    cursor: 'pointer',
                    '&:hover': {
                      boxShadow: 3,
                      transition: 'box-shadow 0.3s ease-in-out'
                    }
                  }}
                />
              ))}
              
              {/* Pagination Controls */}
              {totalPages > 1 && (
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  mt: 4,
                  mb: 2
                }}>
                  <Pagination 
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                    siblingCount={1}
                    boundaryCount={1}
                  />
                </Box>
              )}

              {/* Results Count */}
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center',
                mt: 1,
                color: 'text.secondary' 
              }}>
                <Typography variant="body2">
                  Showing {((page - 1) * PAGE_SIZE) + 1} - {Math.min(page * PAGE_SIZE, totalCount)} of {totalCount} properties
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </DashboardCard>

      {/* Filter Modal */}
      <Modal
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        aria-labelledby="filter-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 1,
          maxHeight: '90vh',
          overflow: 'auto'
        }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            borderColor: 'divider'
          }}>
            <Typography
              variant="h5"
              sx={{
                m: 0,
                lineHeight: 1
              }}
            >
              Filters
            </Typography>
            <IconButton
              onClick={() => setOpenFilter(false)}
              size="small"
              sx={{ p: 1 }}
            >
              <IconX size={20} />
            </IconButton>
          </Box>

          {/* University & Campus Section */}
<Box sx={{ mb: 2 }}>
  <Typography variant="subtitle1" gutterBottom>Country</Typography>
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Select
        fullWidth
        value={tempFilters.country}
        onChange={(e) => {
          const countryId = e.target.value;
          const selectedCountryCurrency = countries.find(c => c.id === countryId)?.currencyCode || '£';
          setSelectedCurrency(selectedCountryCurrency);
          setTempFilters(prev => ({
            ...prev,
            country: countryId,
            university: '',
            campus: ''
          }));
        }}
        displayEmpty
      >
        <MenuItem value="">All Countries</MenuItem>
        {countries?.map((country) => (
          <MenuItem key={country.id} value={country.id}>
            {country.cname}
          </MenuItem>
        ))}
      </Select>
    </Grid>

    <Grid item xs={12}>
      <Typography variant="subtitle1" gutterBottom>University & Campus</Typography>
      <ReactNestedSelect
        ref={nestedSelectRef}
        crmFields={transformUniversitiesToNestedFormat(universities)}
        placeholder="All Universities & Campuses"
        onChange={(selectedObj) => {
          if (selectedObj.parent) {
            setTempFilters(prev => ({
              ...prev,
              university: selectedObj.parent.value,
              universityName: selectedObj.parent.label,
              campus: selectedObj.value,
              campusName: selectedObj.label
            }));
          } else {
            setTempFilters(prev => ({
              ...prev,
              university: selectedObj.value,
              universityName: selectedObj.label,
              campus: '',
              campusName: ''
            }));
          }
          setPage(1);
        }}
        defaultValue={tempFilters.university ? {
          label: tempFilters.campus ? tempFilters.campusName : tempFilters.universityName,
          value: tempFilters.campus || tempFilters.university,
          ...(tempFilters.campus && {
            parent: {
              label: tempFilters.universityName,
              value: tempFilters.university
            }
          })
        } : null}
        fullWidth
      />
    </Grid>

    {/* Distance from University - Moved here */}
    {tempFilters.campus && (
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom>Distance from University</Typography>
        <Slider
          value={filters.distance}
          onChange={(e, newValue) => setFilters({ ...filters, distance: newValue })}
          valueLabelDisplay="auto"
          min={0}
          max={10}
        />
        <Typography variant="body2">{filters.distance} km</Typography>
      </Grid>
    )}
  </Grid>
</Box>
<Grid item xs={12}>
  <Typography variant="subtitle1" gutterBottom>Province & Town</Typography>
  <ReactNestedSelect
      crmFields={nestedProvinces}
      placeholder="All Provinces & Towns"
      onChange={(selectedObj) => {
        if (selectedObj.parent) {
          setSelectedProvince(selectedObj.parent.value);
          setSelectedTown(selectedObj.value);
        } else {
          setSelectedProvince(selectedObj.value);
          setSelectedTown(null);
        }
        setPage(1);
        setAreFiltersApplied(true);
      }}
      defaultValue={selectedProvince ? {
        ...getTownInfo(selectedProvince, selectedTown, nestedProvinces),
        ...(selectedTown && {
          parent: getProvinceInfo(selectedProvince, nestedProvinces)
        })
      } : null}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: '40px',
          height: '40px'
        }),
        valueContainer: (base) => ({
          ...base,
          height: '40px',
          padding: '0 8px'
        }),
        input: (base) => ({
          ...base,
          margin: '0px'
        })
      }}
      fullWidth
    />
</Grid>
{tempFilters.country && (
  <Box sx={{ mb: 3, mt:2 }}>
    <Typography variant="subtitle1" gutterBottom>Price Range</Typography>
    <Slider
      value={filters.priceRange}
      onChange={(e, newValue) => setFilters({ ...filters, priceRange: newValue })}
      valueLabelDisplay="auto"
      min={0}
      max={10000}
    />
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="body2">
        {priceFormattingSymbol(filters.priceRange[0], countries.find(c => c.id === tempFilters.country)?.currencyCode)}
      </Typography>
      <Typography variant="body2">
        {priceFormattingSymbol(filters.priceRange[1], countries.find(c => c.id === tempFilters.country)?.currencyCode)}
      </Typography>
    </Box>
  </Box>
)}
<Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>Availability</Typography>
          <ToggleButtonGroup
            value={filters.isActive}
            exclusive
            onChange={(e, value) => {
              if (value !== null) {
                setFilters({ ...filters, isActive: value });
                setTempFilters(prev => ({ ...prev, isActive: value }));
              }
            }}
            fullWidth
          >
            <ToggleButton value={1} sx={{ py: 1 }}>
              <Box>
                <Typography variant="body2">Available Only</Typography>
              </Box>
            </ToggleButton>
            <ToggleButton value={0} sx={{ py: 1 }}>
              <Box>
                <Typography variant="body2">Show All</Typography>
              </Box>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
          {/* Price Range */}

          {/* Property Type */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom>Property Type</Typography>
            <ToggleButtonGroup
              value={filters.propertyType}
              exclusive
              onChange={(e, newValue) => {
                if (newValue !== null) {
                  setFilters({ ...filters, propertyType: newValue });
                }
              }}
              fullWidth
            >
              <ToggleButton value="all" sx={{ flexDirection: 'column', py: 2 }}>
                <Apps sx={{ mb: 1 }} />
                <Box>
                  <Typography variant="body2">All Types</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    View all properties
                  </Typography>
                </Box>
              </ToggleButton>
              <ToggleButton value="PBSA" sx={{ flexDirection: 'column', py: 2 }}>
                <Apartment sx={{ mb: 1 }} />
                <Box>
                  <Typography variant="body2">Purpose Built</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Student halls
                  </Typography>
                </Box>
              </ToggleButton>
              <ToggleButton value="HMO" sx={{ flexDirection: 'column', py: 2 }}>
                <Home sx={{ mb: 1 }} />
                <Box>
                  <Typography variant="body2">HMO</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Shared houses
                  </Typography>
                </Box>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>


          {/* Distance */}
          

          {/* Rooms & Beds */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom>Rooms and Beds</Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" gutterBottom>Bedrooms</Typography>
                <ButtonGroup size="small">
                  {['Any', 1, 2, 3, 4, '5+'].map(num => (
                    <Button
                      key={num}
                      variant={filters.rooms === num ? 'contained' : 'outlined'}
                      onClick={() => setFilters({ ...filters, rooms: num })}
                    >
                      {num}
                    </Button>
                  ))}
                </ButtonGroup>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" gutterBottom>Beds</Typography>
                <ButtonGroup size="small">
                  {['Any', 1, 2, 3, 4, '5+'].map(num => (
                    <Button
                      key={num}
                      variant={filters.beds === num ? 'contained' : 'outlined'}
                      onClick={() => setFilters({ ...filters, beds: num })}
                    >
                      {num}
                    </Button>
                  ))}
                </ButtonGroup>
              </Grid>
            </Grid>
          </Box>

          {/* Amenities */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom>Amenities</Typography>
            <Select
              multiple
              value={Object.entries(filters.amenities)
                .filter(([_, value]) => value === '1')
                .map(([key]) => key)}
              onChange={(e) => {
                const selectedAmenities = e.target.value;
                setFilters({
                  ...filters,
                  amenities: Object.keys(AMENITIES_CONFIG).reduce((acc, key) => {
                    acc[key] = selectedAmenities.includes(key) ? '1' : '0';
                    return acc;
                  }, {})
                });
              }}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((value) => {
                    const IconComponent = AMENITIES_CONFIG[value].icon;
                    return (
                      <Chip 
                        key={value}
                        label={AMENITIES_CONFIG[value].label}
                        size="small"
                        icon={<IconComponent sx={{ fontSize: 16 }} />}
                      />
                    );
                  })}
                </Box>
              )}
              sx={{ width: '100%' }}
            >
              {Object.entries(AMENITIES_CONFIG).map(([key, { label, icon: Icon }]) => (
                <MenuItem key={key} value={key}>
                  <Checkbox checked={filters.amenities[key] === '1'} />
                  <Icon sx={{ mr: 1, fontSize: 20 }} />
                  <ListItemText primary={label} />
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Management Type */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" gutterBottom>Management Type</Typography>
            <ToggleButtonGroup
              value={filters.managementType}
              exclusive
              onChange={(e, newValue) => {
                if (newValue !== null) {
                  setFilters({ ...filters, managementType: newValue });
                }
              }}
              fullWidth
            >
              <ToggleButton value="all" sx={{ py: 1 }}>
                <Box>
                  <Typography variant="body2">All Types</Typography>
                </Box>
              </ToggleButton>
              <ToggleButton value="1" sx={{ py: 1 }}>
                <Box>
                  <Typography variant="body2">Managed</Typography>
                </Box>
              </ToggleButton>
              <ToggleButton value="2" sx={{ py: 1 }}>
                <Box>
                  <Typography variant="body2">One Time</Typography>
                </Box>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {/* Actions */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button onClick={handleResetAllFilters}
            >
              Clear all
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setPage(1);
                setAreFiltersApplied(true);
                fetchProperties({ pageParam: 1, isShowResults: true });
              }}
            >
              Show results
            </Button>
          </Box>
        </Box>
      </Modal>
      <CustomerListModal
        open={isCustomerModalOpen}
        handleClose={() => setIsCustomerModalOpen(false)}
        currentUser={currentUser}
        setSelectedCustomer={setSelectedCustomer}
        selectedCustomer={selectedCustomer}
      />
      {/* <Footer /> */}
    </Box>
  );
};

const getMinimumBedRate = (rooms) => {
  if (!rooms || !rooms.length) return 0;
  
  return rooms.reduce((minRate, room) => {
    if (!room.beds?.list?.length) return minRate;
    
    const roomMinRate = room.beds.list.reduce((bedMinRate, bed) => {
      const rate = Number(bed?.paymentSplit?.bedRatePerMonth) || 0;
      return rate < bedMinRate ? rate : bedMinRate;
    }, Infinity);
    
    return roomMinRate < minRate ? roomMinRate : minRate;
  }, Infinity) || 0;
};

// Add these helper functions
const getProvinceInfo = (provinceId, provinces) => {
  const numericProvinceId = parseInt(provinceId, 10);

  const province = provinces.find(p => p.value === numericProvinceId);
  return {
    label: province?.label,
    value: province?.value
  };
};

const getTownInfo = (provinceId, townId, provinces) => {
  const numericProvinceId = parseInt(provinceId, 10);
  const numericTownId = parseInt(townId, 10);

  const province = provinces.find(p => p.value === numericProvinceId);
  const town = province?.options?.find(t => t.value === numericTownId);
  
  return {
    label: town?.label,
    value: town?.value
  };
};

export default Explore;